/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_Open_TitleInputs */

const en_gc_story_open_title = /** @type {(inputs: Gc_Story_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open an XLSX. Keep the original.`)
};

const zh_gc_story_open_title = /** @type {(inputs: Gc_Story_Open_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开 XLSX，保留原文件。`)
};

/**
* | output |
* | --- |
* | "Open an XLSX. Keep the original." |
*
* @param {Gc_Story_Open_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_open_title = /** @type {((inputs?: Gc_Story_Open_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_Open_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_open_title(inputs)
	return zh_gc_story_open_title(inputs)
});
export { gc_story_open_title as "gc.story.open.title" }